module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl1-75.37acf197.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl1-75.png
// module id = 3319
// module chunks = 11